import { useEffect, useState, useCallback } from "react";
import { api } from "../../lib/api";
import { RefreshCw } from "lucide-react";

const TYPE_LABELS = {
  welcome: "Bienvenue",
  reset: "Mot de passe oublié",
  confirmation: "Confirmation commande",
  prepared: "En préparation",
  shipped: "Expédiée",
  delivered: "Livrée",
  cancelled: "Annulée",
  refunded: "Remboursée",
  cart_recovery: "Relance panier",
};

const STATUS_STYLE = {
  sent: { color: "#7ee0a0", label: "Envoyé" },
  failed: { color: "#e07a7a", label: "Échec" },
  skipped: { color: "var(--lo-muted)", label: "Ignoré" },
};

export function AdminEmailLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/admin/email-logs?limit=300")
      .then((r) => setLogs(r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="admin-email-logs">
      <div className="flex items-center justify-between mb-6">
        <p className="text-xs" style={{ color: "var(--lo-muted)" }}>
          Historique des e-mails transactionnels (type, destinataire, date, statut). « Ignoré » = SMTP non configuré ou adresse absente.
        </p>
        <button onClick={load} className="btn-ghost inline-flex items-center gap-1.5 h-9 px-4 text-xs" data-testid="email-logs-refresh">
          <RefreshCw size={13} /> Actualiser
        </button>
      </div>
      {loading ? (
        <p className="text-sm" style={{ color: "var(--lo-muted)" }}>Chargement…</p>
      ) : logs.length === 0 ? (
        <p className="text-sm" style={{ color: "var(--lo-muted)" }} data-testid="email-logs-empty">Aucun e-mail envoyé pour le moment.</p>
      ) : (
        <div className="space-y-2">
          {logs.map((l) => {
            const st = STATUS_STYLE[l.status] || STATUS_STYLE.skipped;
            return (
              <div key={l.id} className="card-lux p-4 flex flex-wrap items-center gap-x-6 gap-y-1" data-testid="email-log-row">
                <span className="overline shrink-0" style={{ fontSize: "0.55rem", color: "var(--lo-rose-hi)", minWidth: 130 }}>
                  {TYPE_LABELS[l.type] || l.type}
                </span>
                <span className="text-sm flex-1 min-w-[180px]" style={{ color: "var(--lo-text)" }}>{l.to || "—"}</span>
                <span className="text-xs" style={{ color: "var(--lo-muted)", minWidth: 150 }}>
                  {l.created_at ? new Date(l.created_at).toLocaleString("fr-FR") : "—"}
                </span>
                <span className="text-xs font-semibold uppercase tracking-wider shrink-0" style={{ color: st.color, minWidth: 70 }}>
                  {st.label}
                </span>
                {l.error && <span className="text-[10px] w-full" style={{ color: "var(--lo-muted)" }}>{l.error}</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
